<template>
  <div class="content-container" id="shopping_cart" :key="'shopping_cart_items_nb_' + bookingStore.inscriptions.length">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 pt-3 pb-2 radius-bottom mb-2">
      <v-badge :content="bookingStore.nb_articles" color="primary-dark">
        <v-icon icon="mdi-cart" color="darkblue" size="25"></v-icon>
      </v-badge>
      <h4 class="font-weight-bold">Mon panier</h4>
    </div>
    <div class="mb-3" v-if="mainStore.inscription_as_admin">
      <v-alert><v-icon icon="mdi-information" color="primary-dark" size="20"></v-icon> En inscription administrateur,
        le panier est donné à titre indicatif. </v-alert>
    </div>
    <div class="d-flex flex-row justify-space-between align-center">
      <div>Sous total</div>
      <div>{{ bookingStore.prix }}€</div>
    </div>
    <div class="d-flex flex-row justify-space-between align-center">
      <div>Frais de gestion</div>
      <div>{{ bookingStore.taxe }}€</div>
    </div>
    <div class="d-flex flex-row justify-space-between align-center font-weight-bold">
      <div>Total</div>
      <div>{{ bookingStore.prix_total }}€</div>
    </div>

    <div class="d-flex flex-column gap mt-2">
      <div class="spo-card rounded" v-for="(inscription, index_inscription) in bookingStore.inscriptions"
        :key="index_inscription">
        <div class="px-2 py-1 font-weight-bold bg-spo-blue-grey">{{ get_nom_coureur(inscription, index_inscription) }}
        </div>
        <CartCoureurItem class="px-2 py-1" :item="inscription"></CartCoureurItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";

import CartCoureurItem from "@/components/App/Shopping_Cart/Cart_Coureur_Item.vue";
export default {
  components: { CartCoureurItem },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  methods: {
    get_nom_coureur(inscription, index) {
      let coureur = inscription.coureur;
      let nom = coureur.get_nom();
      if (nom.length > 1) {
        if (inscription.get_equipe_name() != '') {
          return nom + " - Equipe " + inscription.get_equipe_name();
        }
        return nom;
      }

      if (!this.mainStore.is_default_mode) {
        return "Participant n°" + parseInt(index + 1);
      } else {
        return "Coureur n°" + parseInt(index + 1);
      }
    },
  },
  created() {
    this.bookingStore.compute_cart(this.mainStore.inscription_vip);
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/Cart.scss";
</style>